export const LOCATIONS = [
  {
    title: "Goa",
    img: "/images/locations/goa.png",
  },
  {
    title: "Nagpur",
    img: "/images/locations/nagpur.jpeg",
  },
  {
    title: "Pune",
    img: "/images/locations/pune.webp",
  },
  {
    title: "Bengaluru",
    img: "/images/locations/bangalore.webp",
  },
  {
    title: "Nashik",
    img: "/images/locations/nashik.jpg",
  },
];
